/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { items } from "../../data/items.ts";
import "../../styles/GunScreensaverV2.css";

const GunScreensaverV2 = () => {
  const [currentItem, setCurrentItem] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const autoAdvanceTimeoutRef = useRef(null);

  const clearAllTimeouts = () => {
    clearTimeout(autoAdvanceTimeoutRef.current);
    autoAdvanceTimeoutRef.current = null;
  };

  const loadNewItem = useCallback(() => {
    clearAllTimeouts();

    const item = items[Math.floor(Math.random() * items.length)];
    const imgIdx = Math.floor(Math.random() * item.images.length);

    setCurrentItem(item);
    setCurrentImageIndex(imgIdx);
    // Auto advance after 10 seconds
    autoAdvanceTimeoutRef.current = setTimeout(loadNewItem, 10000);
  }, []);

  useEffect(() => {
    loadNewItem();
    return clearAllTimeouts;
  }, [loadNewItem]);

  if (!currentItem)
    return <div className="gun-screensaver-v2">Loading…</div>;

  return (
    <div className="gun-screensaver-v2">
      <div className="v2-content">
        
        {/* Price Circle */}
        <div className="v2-price-circle" key={`price-${currentItem.id}`}>
            ${currentItem.price}
        </div>

        {/* Top Overlay: Title */}
        <div className="v2-top-overlay" key={`title-${currentItem.id}`}>
            <h1 className="v2-title">{currentItem.title}</h1>
        </div>

        {/* Fullscreen Image */}
        <div className="v2-image-container" key={`img-${currentItem.id}`}>
          {currentItem.images && currentItem.images.length > 0 && (
            <img
                src={currentItem.images[currentImageIndex]}
                alt={currentItem.title}
                className="v2-fullscreen-image"
            />
          )}
        </div>

        {/* Bottom Overlay: Tags */}
        <div className="v2-bottom-overlay" key={`tags-${currentItem.id}`}>
            <div className="v2-tags">
                {(currentItem.category || "").split(',').map((tag, index, array) => (
                    <React.Fragment key={tag}>
                        <span className="v2-tag">{tag.trim()}</span>
                        {index < array.length - 1 && <span className="v2-tag-separator">|</span>}
                    </React.Fragment>
                ))}
            </div>
        </div>

      </div>
    </div>
  );
};

export default GunScreensaverV2;
